<template>
    <div class="templateAutoresponder">
        <h2>{{$t('title')}}</h2>

        <b-form-group :label="$t('selectTemplate')">
            <b-select v-model.number="autoresponderid" :options="autoresponderOptions"></b-select>
        </b-form-group>
        <small v-if="checklog > 0">{{$t('frequency', { time: frequencyTime })}}</small>

        <b-form-group :label="$t('dates')">
            <date-time-picker v-model="rule.datefrom" date-only optional close-on-click
                    @input="checkDateFrom"></date-time-picker>
            {{$t('dateSeparator')}}
            <date-time-picker v-model="rule.dateto" date-only optional close-on-click
                    @input="checkDateTo"></date-time-picker>

        </b-form-group>

        <b-checkbox v-model="rule.ruleenable">{{$t('enable')}}</b-checkbox>

        <autoresponder-template-variables v-model="rule.customfields"
                :template="autoresponderText"></autoresponder-template-variables>

        <b-button @click="doSave" variant="primary" :disabled="saving">
            {{$t('save')}}
        </b-button>
        <b-button @click="doClear">
            {{$t('clear')}}
        </b-button>
        <autoresponder-preview :autoresponder="autoresponder" :rule="rule"></autoresponder-preview>

        <font-awesome-icon :class="{ saveIcon: true, savingIcon: saving }" spin
                icon="spinner-third"></font-awesome-icon>
        <span class="success" v-show="saveSuccess">{{$t('saveSuccess')}}</span>
        <span class="error">{{saveError}}</span>
    </div>
</template>

<script>
import AutoresponderTemplateVariables from '@/components/autoresponderTemplateVariables';
import axios from 'axios';
import DateTimePicker from '@/components/dateTimePicker';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Duration } from 'luxon';
import AutoresponderPreview from '@/components/autoresponderPreview';

export default {
  name: 'templateAutoresponder',
  components: { AutoresponderTemplateVariables, DateTimePicker, FontAwesomeIcon, AutoresponderPreview },
  i18nOptions: { keyPrefix: 'settings.autoresponders.template' },
  data: function() {
    return {
      autoresponderid: 0,
      rule: { customfields: '', ruleenable: false, datefrom: '', dateto: '' },
      saving: false,
      saveSuccess: false,
      saveError: ''
    };
  },
  props: {
    autoresponders: Array,
    rules: Array
  },
  watch: {
    rules(newVal) {
      if (newVal.length === 1) {
        this.rule = Object.assign({}, newVal[0]);
      } else if (newVal.length === 0) {
        this.setBlankRule();
      }
    }
  },
  created() {
    this.autoresponderid = -1;
    if (this.rules.length > 0) {
      this.autoresponderid = this.rules[0].autoresponderid;
      this.rule = Object.assign({}, this.rules[0]);
      if (this.autoresponders.findIndex(a => a.id === this.autoresponderid) === -1) {
        this.autoresponderid = -1;
      }
    }
    if (this.autoresponderid === -1) {
      this.autoresponderid = this.autoresponders[0].id;
      this.setBlankRule();
    }
  },
  methods: {
    setBlankRule() {
      this.rule = {
        autoresponderenable: true,
        autoresponderid: this.autoresponderid,
        autoresponderowner: -1,
        customfields: '',
        datefrom: '',
        datetimefrom: '',
        datetimeto: '',
        dateto: '',
        daysofweek: '0123456',
        id: 0,
        locked: false,
        name: 'Default',
        priority: 0,
        ruleenable: false,
        sender: '',
        subject: '',
        timefrom: '',
        timeto: '',
        usernumber: 0
      };
    },
    doClear() {
      this.saveSuccess = false;
      this.saveError = '';
      this.saving = true;
      axios.put('/rest/user/settings/autoresponderrules', { rules: [] })
        .then(d => {
          this.$emit('setAutoresponderRules', d.data.rules);
          this.saveSuccess = true;
          this.$emit('remove');
        })
        .catch(e => {
          this.saveError = this.$t('saveAutoresponderRuleError', { error: e.message });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    doSave() {
      this.saveSuccess = false;
      this.saveError = '';
      this.saving = true;
      this.rule.autoresponderid = this.autoresponderid;
      axios.put('/rest/user/settings/autoresponderrules', { rules: [this.rule] })
        .then(d => {
          this.$emit('setAutoresponderRules', d.data.rules);
          this.saveSuccess = true;
        })
        .catch(e => {
          this.saveError = this.$t('saveAutoresponderRuleError', { error: e.message });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    checkDateFrom() {
      if (this.rule.datefrom && (this.rule.datefrom > this.rule.dateto)) {
        this.rule.dateto = '';
      }
    },
    checkDateTo() {
      if (this.rule.dateto && (this.rule.dateto < this.rule.datefrom)) {
        this.rule.datefrom = '';
      }
    }
  },
  computed: {
    autoresponderOptions() {
      return this.autoresponders.map(a => {
        return { text: a.name, value: a.id };
      });
    },
    autoresponder() {
      return this.autoresponders.find(a => a.id === this.autoresponderid);
    },
    checklog() {
      if (this.autoresponder) {
        return this.autoresponder.checklog;
      } else {
        return 0;
      }
    },
    autoresponderText() {
      if (this.autoresponder) {
        return this.autoresponder.text;
      } else {
        return '';
      }
    },
    frequencyTime() {
      let dur = Duration.fromObject({ hours: this.autoresponder.checklog });
      return dur.as('days');
    }
  }
};
</script>

<style scoped lang="scss">

</style>
